var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "stars band-review__stars" },
    [
      _vm._l(_vm.fullStars, function (n) {
        return _c("span", {
          key: "fullStar" + n,
          staticClass: "icon-full-star",
        })
      }),
      _vm._v(" "),
      _vm._l(_vm.halfStars, function (n) {
        return _c("span", {
          key: "halfStar" + n,
          staticClass: "icon-half-star",
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }